import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { AuditReportView } from "@/components/AuditReportView";

export default function AuditReport() {
  const { token } = useParams();
  const [report, setReport] = useState(null);
  const [state, setState] = useState("loading");

  useEffect(() => {
    api
      .get(`/public/invoice-audit/${token}`)
      .then(({ data }) => { setReport(data); setState("ok"); })
      .catch(() => setState("error"));
  }, [token]);

  return (
    <div className="min-h-screen bg-[#0B1F33] text-white font-body">
      <header className="h-16 flex items-center justify-between px-6 sm:px-10 border-b border-white/10">
        <Link to="/" className="font-body font-bold text-2xl tracking-tight" data-testid="audit-report-brand">
          Retain<span className="text-[#0E7C7B]">Proof</span><sup className="text-[0.5em] font-normal align-super">™</sup>
        </Link>
        <Link to="/consultation" data-testid="audit-report-run-own">
          <Button className="bg-[#D5A44A] text-black hover:bg-[#B8923D] rounded-none h-10 px-5">Audit your own invoice</Button>
        </Link>
      </header>

      <div className="max-w-3xl mx-auto px-6 sm:px-10 py-16">
        {state === "loading" && (
          <div className="flex items-center gap-3 text-white/50 font-mono-data text-sm" data-testid="audit-report-loading">
            <Loader2 className="h-4 w-4 animate-spin" /> Loading audit…
          </div>
        )}
        {state === "error" && (
          <div data-testid="audit-report-notfound">
            <h1 className="font-display text-3xl">Audit not found</h1>
            <p className="mt-3 text-white/60">This link may have expired or is invalid.</p>
            <Link to="/consultation"><Button className="mt-6 bg-[#D5A44A] text-black hover:bg-[#B8923D] rounded-none h-11 px-6">Run a free audit</Button></Link>
          </div>
        )}
        {state === "ok" && report && (
          <>
            <p className="font-mono-data text-xs uppercase tracking-[0.2em] text-[#D5A44A] mb-3">Independent invoice audit</p>
            <h1 className="font-display text-4xl">{report.firm_name ? `Audit for ${report.firm_name}` : "Invoice audit"}</h1>
            <div className="mt-8 bg-white text-[#0B1F33] p-8">
              <AuditReportView report={report} />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
